import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/api.service';
import { User } from '../models/user';
import { AccountLocation } from '../../locations/models/account-location';
import { UserClaims } from '../models/user-claims';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiService: ApiService
  ) {}

  getLoggedInUser(): Observable<User> {
    return this.http.get<User>(this.apiService.buildUrl('api/user/getlogin'));
  }

  registerLogin(): Observable<User> {
    return this.http.post<User>(this.apiService.buildUrl('api/user/RegisterLogin'), null);
  }

  getAllLocations(filter?: string): Observable<AccountLocation[]> {
    const suffix = filter ? `/${encodeURIComponent(filter)}` : '/';
    return this.http.get<AccountLocation[]>(
      this.apiService.buildUrl(`api/user/GetAllLocations${suffix}`)
    );
  }

  getAllLocationsByMagId(magId: string): Observable<AccountLocation[]> {
    return this.http.get<AccountLocation[]>(
      this.apiService.buildUrl(`api/user/GetAllLocationsByMagId/${encodeURIComponent(magId)}`)
    );
  }

  getUserClaims(): Observable<UserClaims> {
    return this.http.get<UserClaims>(this.apiService.buildUrl('api/user/claims'));
  }
}
